import { useMemo } from 'react';

import { useCallApi } from '@hooks/useCallApi';
import type {
  MutationFunction,
  UseMutationOptions,
  UseMutationResult,
} from '@tanstack/react-query';
import { useMutation as useOldMutation } from '@tanstack/react-query';

export function useMutation<
  TData = unknown,
  TError = unknown,
  TVariables = void,
  TContext = unknown,
>(
  mutationFn: MutationFunction<TData, TVariables>,
  options?: UseMutationOptions<TData, TError, TVariables, TContext>,
): UseMutationResult<TData, TError, TVariables, TContext> {
  const finalOptions = useMemo(
    () => ({
      retry: false,
      ...options,
    }),
    [options],
  );

  const finalFn = useCallApi(mutationFn);

  const query = useOldMutation(finalFn, finalOptions);

  return query;
}
